import { SuggestionData } from "@/common/types/highlightTextArea.type";
import { createPortal } from "react-dom";
import { MenuPosition } from ".";
import { Ref, useId } from "react";
import { cn } from "@/common/utils/cn";

interface SuggestionsMenuProps {
  showSuggestions: boolean;
  filteredSuggestions: SuggestionData[];
  menuPosition: MenuPosition;
  selectedIndex: number;
  handleSuggestionClick: (suggestion: SuggestionData) => void;
  menuRef: Ref<HTMLDivElement>
}

const SuggestionsMenu = ({
  showSuggestions,
  filteredSuggestions,
  menuPosition,
  selectedIndex,
  handleSuggestionClick,
  menuRef,
}: SuggestionsMenuProps) => {
  const uniqueId = useId();

  if (!showSuggestions || filteredSuggestions.length === 0 || (menuPosition.top === 0 && menuPosition.left === 0)) {
    return null;
  }

  const menuElement = (
    <div
      ref={menuRef}
      className="fixed bg-[#212121] border border-[#212121] rounded-md shadow-lg overflow-y-auto max-h-64 w-96 thin-scroll"
      style={{
        top: `${menuPosition.top}px`,
        left: `${menuPosition.left}px`,
        zIndex: 9999,
      }}
      data-testid="highlight_suggestion_menu"
    >
      {filteredSuggestions.map((suggestion, index) => (
        <div
          key={`${uniqueId}-${suggestion.value}`}
          className={cn(
            'px-3 py-3 cursor-pointer hover:bg-white-200 border-b border-[#212121] last:border-b-0 transition-colors flex flex-col gap-px',
            index === selectedIndex && 'bg-white-200 selected-suggestion'
          )}
          onClick={() => handleSuggestionClick(suggestion)}
          data-testid={index === selectedIndex && 'highlight_suggestion_selected_option'}
        >
          <p className='text-[#FC9CE0] text-xs'>
            {suggestion.label}
          </p>

          {suggestion.description && (
            <p className='text-white-400 text-xs italic'>
              {suggestion.description}
            </p>
          )}
        </div>
      ))}
    </div>
  );

  return createPortal(menuElement, document.body);
}

export default SuggestionsMenu;
